import React from 'react';
import './TextQuestion.scss';

interface TextQuestionProps {
    questionId: number;
    value: string;
    onChange: (questionId: number, value: string) => void;
    placeholder?: string;
    isFillInBlank?: boolean;
    blankLabels?: string[];
}

export const TextQuestion: React.FC<TextQuestionProps> = ({ 
    questionId, 
    value, 
    onChange, 
    placeholder = "답을 입력해주세요.",
    isFillInBlank = false,
    blankLabels = ["ㄱ", "ㄴ"]
}) => {
    if (isFillInBlank) {
        // Parse the value to extract individual answers
        const parseValue = (val: string): string[] => {
            if (!val) return new Array(blankLabels.length).fill('');
            
            const result: string[] = [];
            blankLabels.forEach(label => {
                const regex = new RegExp(`${label}: ([^\\n]*)`);
                const match = val.match(regex);
                result.push(match ? match[1] : '');
            });
            return result;
        };
        
        const values = parseValue(value);
        
        return (
            <div className="TextAnswer">
                {blankLabels.map((label, index) => (
                    <input
                        key={index}
                        type="text"
                        className="TextInput"
                        placeholder={`${label}을 입력해주세요.`}
                        value={values[index] || ''}
                        onChange={(e) => {
                            const newValues = [...values];
                            newValues[index] = e.target.value;
                            // Format as "(ㄱ: ~~~~\nㄴ: ~~~~)"
                            const formattedValue = blankLabels
                                .map((lbl, idx) => `${lbl}: ${newValues[idx] || ''}`)
                                .join('\n');
                            onChange(questionId, formattedValue);
                        }}
                    />
                ))}
            </div>
        );
    }

    return (
        <div className="TextAnswer">
            <input
                type="text"
                className="TextInput"
                value={value}
                onChange={(e) => onChange(questionId, e.target.value)}
                placeholder={placeholder}
            />
        </div>
    );
};